"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleListing = void 0;
var React = require("react");
var styles_1 = require("@/pages/newsAndInsights/components/ArticleListing/styles");
var ArticleItem_1 = require("@/pages/newsAndInsights/components/ArticleItem/ArticleItem");
exports.ArticleListing = function (_a) {
    var newsArticles = _a.newsArticles;
    var items = newsArticles.items, translate = newsArticles.translate;
    var renderItems = function () { return (items.map(function (item) { return (React.createElement(ArticleItem_1.ArticleItem, { key: item.id, articleItem: item, translate: translate })); })); };
    if (items.length > 0) {
        return (React.createElement(styles_1.Container, { id: "articles" }, renderItems()));
    }
    return null;
};
